import React from 'react';

import './SideMenuLand.css';
import styled from 'styled-components';
import {Link} from 'react-router-dom';


//import logo from './SideMenu/eartdna_logo.png';
import home from '../../assets/home.png';
import oceans from '../../assets/oceans.png';
import land from '../../assets/land.png';
import air from '../../assets/air.png';
import near_space from '../../assets/near_space.png';
import take_action from '../../assets/take_action.png';
import logo from '../../assets/earthdna_logo.png';
import donate from '../../assets/donate.png';

const Earth = styled.h3`
  color:white;
  font-family: roboto;
  font-weight: 500;
  justify-content: left;
  font-size:0.9rem;
  margin:0px;
  display: inline-block;
  margin-left:50px;
`;

const Dna = styled.h3`
  color:#00B292;
  font-family: roboto;
  font-weight: 500;
  justify-content: left;
  font-size:0.9rem;
  margin:0px;
`;
const Contain= styled.div`
  display: flex;
  flex-direction:row;
  width: 100%;
  height: auto;
  float:bottom;
`;
const Btnactive= styled.div`
  border: none;
  background-color: rgba(255, 255, 255, 0.18); 
    border: none;
    color: #ffffff;
    vertical-align: middle;
    text-align: middle;
    text-decoration: none;
    font-family: roboto;
    font-weight: 400;
    padding-top: 10px;
    padding-bottom: 10px;
    flex-direction: row; 
    font-size: .7em;
    width:100%;
    display: flex;
    align-items: center;
    justify-content: left;
`;

const Btncontainer= styled.div`
  opacity: 60%;
  border: none;
  background-color: rgba(255, 255, 255, 0.0); 
    border: none;
    color: #ffffff;
    vertical-align: middle;
    text-align: middle;
    text-decoration: none;
    font-family: roboto;
    font-weight: 400;
    padding-top: 10px;
    padding-bottom: 10px;
    flex-direction: row; 
    font-size: .7em;
    width:100%;
    display: flex;
    align-items: center;
    justify-content: left;

     &:hover {
    background-color: rgba(255, 255, 255, 0.18); 
    opacity:100%;
    transition-duration: .2s;
  }
`;
const Menuicon = styled.img`
  margin-left:15px;
  margin-right:10px;
  justify-content:center;
  align-self:center;
  width:20px;
  height:20px;

`;

const sideMenuLand = props => (
    <div className = "side-menu">
    <nav>
      <ul>
      <li><div className= "spacer"></div></li>

      <Link to="/">
      <li><Btncontainer><Menuicon src= {home}/><div> HOME </div></Btncontainer>
      </li></Link>

      <Link to="/Oceans">
      <li><Btncontainer><Menuicon src= {oceans}/><div> OCEANS </div></Btncontainer>
      </li></Link>

      <Link to="/Land">
      <li><Btnactive><Menuicon src= {land}/><div> LAND </div></Btnactive>
      </li></Link>

      <Link to="/Atmosphere">
      <li><Btncontainer><Menuicon src= {air}/><div> ATMOSPHERE </div></Btncontainer>
      </li></Link>

      <Link to="/Near-Space">
      <li><Btncontainer><Menuicon src= {near_space}/><div> NEAR SPACE </div></Btncontainer>
      </li></Link>

      <Link to="/Take-Action">
      <li><Btncontainer><Menuicon src= {take_action}/><div> TAKE ACTION </div></Btncontainer>
      </li></Link>
      
      <li><div className= "spacer"></div></li>
      <a href= "https://earthdna.org/home/donate/"target="_blank"rel="noopener noreferrer">
      <li><Btncontainer><Menuicon src= {donate}/><div> DONATE </div></Btncontainer>
      </li></a>
      <li><img className = "logo"alt="EarthDNA logo"src={logo}/></li>
      <a href= "https://earthdna.org/"target="_blank"rel="noopener noreferrer">
      <div>
      <h2>POWERED BY</h2>
      <header>
      <Contain>
      <Earth>EARTH</Earth>
      <Dna>DNA</Dna>
      </Contain>
      </header>
      </div>
      </a>
      
    </ul>
    
    </nav>


    </div>
  )



export default sideMenuLand;